<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {
      fanhuiIcon: `${this.$cdnLink}/wanXin/legend/l-7.png`,
      zhanghaoIcon: `${this.$cdnLink}/wanXin/legend/l-4.png`,
      idCardIcon: `${this.$cdnLink}/wanXin/legend/l-17.png`
    }
  }
};
</script>

<style lang="scss" module>
@import '../../assets/css/legend.scss';

.wrap {
  @include common-window();
  > header {
    position: relative;
    .fanhui {
      position: absolute;
      top: 0.72rem;
      right: 0.26rem;
      width: .58rem;
      height: .6rem;
    }
  }
  > main {
    padding: 0.35rem 0.2rem;
    overflow-y: auto;
    .antiIndulged {
      .content {
        > p {
          padding: 0 0 0 0.15rem;
          font-size: 0.24rem;
          color: #ffffff;
        }
      }
      .bindFm {
        width: 4.44rem;
        height: 0.68rem;
        border: 4.86px solid;
        border-image: linear-gradient(0deg, #130f0d 0%, #130f0d 8%, #371e14 50%, #130f0d 92%, #130f0d 100%) 7 7;
        box-shadow: 0px 3.47px 13.86px 0.17px rgba(5,0,0,0.75), 0px 0px 12.51px 0px rgba(255,161,82,0.30) inset; 
        color: #FFFFFF;
        border-radius: 0.1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.15rem auto;
        > img {
          margin-left: .06rem;
          width: .26rem;
        }
        > input {
          width: 3.8rem;
          margin: 0 0.1rem;
          background: none;
          border: none;
        }
      }
      .btnGp {
        display: flex;
        justify-content: center;
        margin-top: 0.15rem;
        > button {
          @include common-button();
          width: 2rem;
          height: 0.58rem;
          margin: 0 0.2rem;
        }
      }
      .antiInduledHint {
        color: #ffffff;
        font-size: 0.2rem;
        line-height: 0.26rem;
        text-align: center;
        margin-top: 0.1rem;
        > button {
          background: none;
          border: none;
          outline: none;
          color: #FFE85D;
          font-size: 0.2rem;
        }
        > a {
          color: #FFE85D;
        }
      }
      .antiInduledCp {
        position: absolute;
        left: 0;
        top: -1000rem;
        z-index: -1;
      }
    }
  }
  // 全屏版本
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
      }
      .fanhui {
        position: absolute;
        top: 36px;
        right: 13px;
        width: 29px;
        height: 30px;
      }
    }
    > main {
      padding: 17px 10px;
      overflow-y: auto;
      .antiIndulged {
        .content {
          min-height: 100px;
        }
        p {
          padding: 0 0 0 7px;
          font-size: 12px;
        }
        .bindFm {
          width: 222px;
          height: 34px;
          border: 4.86px solid;
          border-image: linear-gradient(0deg, #130f0d 0%, #130f0d 8%, #371e14 50%, #130f0d 92%, #130f0d 100%) 7 7;
          box-shadow: 0px 3.47px 13.86px 0.17px rgba(5,0,0,0.75), 0px 0px 12.51px 0px rgba(255,161,82,0.30) inset; 
          color: #FFFFFF;
          border-radius: 0.1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 7px auto;
          > img {
            width: 13px;
            margin-left: 3px;
          }
          > input {
            width: 190px;
            margin: 0 5px;
            background: none;
            border: none;
          }
        }
        .btnGp {
          display: flex;
          justify-content: center;
          margin-top: 7px;
          > button {
            @include full-screen-button();
            width: 100px;
            height: 29px;
            margin: 0 10px;
          }
        }
        .antiInduledHint {
          color: #ffffff;
          font-size: 10px;
          line-height: 13px;
          text-align: center;
          margin-top: 10px;
          > a {
            background: none;
            border: none;
            outline: none;
            color: #FFE85D;
            font-size: 10px;
          }
          > span {
            color: #FFE85D;
          }
        }
        .antiInduledCp {
          position: absolute;
          left: 0;
          top: -1000px;
          z-index: -1;
        }
      }
    }
  }
}
</style>
,
